import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

export class Tag extends Model({
  id: types.identifierNumber,
  name: types.string,
  order: types.number,
  isRecommended: types.boolean,
  // TODO: maybe will remove it into local store(useSearchHook as example)
  isSelected: false,
}) {
  setIsSelected(value: boolean) {
    this.isSelected = value;
  }

  clearSelection() {
    this.isSelected = false;
  }
}

export const TagModel = model(Tag);
